module.exports = __webpack_public_path__ + "static/img/4_1_6.7674b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_6.png
// module id = /GSa
// module chunks = 1